import * as _ from 'lodash';

export class GridFiltersService {

    prepare( filters ) {

        const results = {};
        for (const key of Object.keys(filters) ) {
            const value = filters[key];
            if (_.isArray(value)) {
                _.forEach(value, function (item, index) {
                    if ( item.name && item.name.indexOf(':') > -1 ) {
                        const data = item.name.split(':');
                        results[data[0] + '[' + index + ']'] = data[1];
                    } else {
                        results[key + '[' + index + ']'] = item;
                    }
                });
            } else {
                if ( typeof value !== 'undefined') {
                    results[key] = value;
                }
            }
        }
        return results;
    }
}



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/services/grid.filters.service.ts